import { useRef } from 'react'
import { useOnInView } from 'react-intersection-observer'
import type { UserSubscription } from 'src/services/apollo/generated/graphql'
import { Interval } from 'src/services/apollo/generated/graphql'
import type { CampaignAdEntry } from 'src/services/orpc/campaignAds'
import { track } from 'src/utils/tracker'
import { UserSubscriptionStatus } from 'src/utils/user'
import type { CampaignTrackParams } from './campaign'

/**
 * Check if ad should be shown a user with a specific membership subscription
 */
export function checkAdUnitConditionWithMembership(
  entry?: CampaignAdEntry,
  subscription?: Pick<UserSubscription, 'interval' | 'status'>,
) {
  if (!entry) return false
  if (
    !subscription?.interval ||
    subscription.status !== UserSubscriptionStatus.active
  )
    return true

  const { isShownForMonthlyMember, isShownForYearlyMember } = entry

  if (subscription.interval === Interval.Month && !isShownForMonthlyMember)
    return false
  if (subscription.interval === Interval.Year && !isShownForYearlyMember)
    return false
  return true
}

export const useCampaignViewTracker = (param: CampaignTrackParams) => {
  const trackedRef = useRef(false)
  return useOnInView(inViewport => {
    if (inViewport && !trackedRef.current) {
      track('campaign_view', param)
      trackedRef.current = true
    }
  })
}
